// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1__a1f7eb137ec0af3156e6","cls2":"AutoCompleteResults-cls2___ac24b7655c96dc9c8dd AutoCompleteResults-cls1__a1f7eb137ec0af3156e6"};